module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/薪资福利.c72e0e5e.png";